import { runloopCreateApiKeyUrl } from '@reflex/shared/external-links';
import type { SecretStatusItem } from '@/lib/types';

/**
 * The "Get key" link for an open secret dialog.
 *
 * `ApiKeysStage`'s manual-key fallback slot carries no `docsUrl`, because
 * `usePlatformUrl()` is null until `GET /api/config` answers and may stay null
 * if it fails. Resolving here rather than when the dialog opens means an admin
 * who opened it early still gets their own console once config lands.
 *
 * Server-supplied slots already carry a resolved `docsUrl` and pass through.
 * Separate from `ApiKeysStage.tsx` so that file only exports components
 * (`react-refresh/only-export-components`).
 */
export function dialogDocsUrl(
  secret: SecretStatusItem,
  platformUrl: string | null,
): string | undefined {
  if (secret.docsUrl) return secret.docsUrl;
  return secret.key === 'RUNLOOP_API_KEY' ? runloopCreateApiKeyUrl(platformUrl) : undefined;
}
